import { Route, Routes, useLocation } from 'react-router';
import { useBaseState } from '@edikk-edikk/redux/slice-base';
import loadable from '@loadable/component';
import { ContentLoader, useLanguageControl } from '@edikk-edikk/ui';
import { DynamicPages } from '#base/components/DynamicPages';

const Home = loadable(() => import('#baseHome/containers/Home'), {
  fallback: <ContentLoader />,
});

const Routers = () => {
  const { apiError } = useBaseState();
  const { pathname } = useLocation();
  const languageControl = useLanguageControl();
  const { routePrefix } = languageControl.getLanguageConfigByPathname(pathname);

  if (apiError) {
    return null;
  }

  return (
    <Routes>
      <Route
        path={`${routePrefix}/`}
        element={<Home />}
      />
      <Route
        path={`${routePrefix}/*`}
        element={<DynamicPages />}
      />
    </Routes>
  );
};

export { Routers };
